import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Box,
  Input,
  FormControl,
  FormLabel,
  FormHelperText,
} from '@material-ui/core';
import { postUploadExcel } from '../../requests/api/survey-emails';

const FileUploadDialog = ({ open, onClose }) => {
  const { t } = useTranslation();
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [errorFile1, setErrorFile1] = useState(null);
  const [errorFile2, setErrorFile2] = useState(null);

  const handleFile1Change = (event) => {
    setFile1(event.target.files[0]);
  };

  const handleFile2Change = (event) => {
    setFile2(event.target.files[0]);
  };

  const handleSubmit = async () => {
    setErrorFile1(null);
    setErrorFile2(null);
    let error1;
    let error2;
    let resp;
    if (file1) {
      resp = await postUploadExcel(file1, 'surveyEmails');
      if (resp.status === 200) {
        if (resp.data.data.resp.errors) {
          error1 = resp.data.data.resp.errors;
          setErrorFile1(resp.data.data.resp.errors);
        }
      }
    }
    if (file2) {
      resp = await postUploadExcel(file2, 'surveyEmailLocations');
      if (resp.status === 200) {
        if (resp.data.data.resp.errors) {
          error2 = resp.data.data.resp.errors;
          setErrorFile2(resp.data.data.resp.errors);
        }
      }
    }
    if (error1 === null && error2 === null) {
      onClose();
    }
  };

  const handleCancel = () => {
    setFile1(null);
    setFile2(null);
    onClose();
  };

  const generateTemplate = (headers, name) => {
    const data = [
      headers,
    ];

    const workbook = XLSX.utils.book_new();

    const worksheet = XLSX.utils.aoa_to_sheet(data);

    XLSX.utils.book_append_sheet(workbook, worksheet, name);

    XLSX.writeFile(workbook, `${name}.xlsx`);
  };

  const handleDownloadTemplate1 = () => {
    generateTemplate(['Subject', 'Survey_ID', 'Questions', 'Mails', 'Body'], 'TemplateMail');
  };

  const handleDownloadTemplate2 = () => {
    generateTemplate(['Survey_ID', 'Mails', 'Location_ID'], 'TemplateMailLocation');
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{t('task.dialogMail.title')}</DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <Typography variant="body1">
            {t('task.dialogMail.body')}
          </Typography>
        </Box>

        <Box mb={3}>
          <FormControl fullWidth error={Boolean(errorFile1)}>
            <FormLabel>{t('task.dialogMail.fileMail')}</FormLabel>

            <Box mb={1}>
              <Button
                variant="outlined"
                size="small"
                onClick={handleDownloadTemplate1}
              >
                {t('task.dialogMail.dowloadTemplateMail')}
              </Button>
            </Box>

            <Input
              type="file"
              onChange={handleFile1Change}
              inputProps={{ accept: '.xlsx, .xls' }}
            />

            {
            (errorFile1 != null ? errorFile1 : []).map((err, idx) => {
              const { row } = err;

              return (
                <FormHelperText key={idx}>
                  {row
                    ? `Row: ${row.surveyId ?? '-'} — ${err.message}`
                    : `error: [batch: ${err.batchNumber}, message: ${err.message}, field: ${err.field}, value: ${err.value}, type: ${err.type}]`}
                </FormHelperText>
              );
            })}
          </FormControl>
        </Box>

        <Box mb={3}>
          <FormControl fullWidth error={Boolean(errorFile2)}>
            <FormLabel>{t('task.dialogMail.fileMailLocation')}</FormLabel>

            <Box mb={1}>
              <Button
                variant="outlined"
                size="small"
                onClick={handleDownloadTemplate2}
              >
                {t('task.dialogMail.dowloadTemplateMailLocation')}
              </Button>
            </Box>

            <Input
              type="file"
              onChange={handleFile2Change}
              inputProps={{ accept: '.xlsx, .xls' }}
            />

            {
            (errorFile2 != null ? errorFile2 : []).map((err, idx) => {
              const { row } = err;

              return (
                <FormHelperText key={idx}>
                  {row
                    ? `Row: ${row.locationId ?? '-'} - ${row.surveyId ?? '-'} — ${err.message}`
                    : `error: [batch: ${err.batchNumber}, message: ${err.message}, field: ${err.field}, value: ${err.value}, type: ${err.type}]`}
                </FormHelperText>
              );
            })}
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          {t('task.dialogMail.cancel')}
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained">
          {t('task.dialogMail.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FileUploadDialog;
